import { themeCfg } from '../../theme/theme'
import { Group, Stack, TextInput } from '@mantine/core'
import AppIcon from '../common/AppIcon'
import { useTranslation } from 'react-i18next'

interface CustomProps {
  leftSection?: React.ReactNode[]
  rightSection?: React.ReactNode[]
  dataFacade?: any
  breakpoint?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
}

const AppToolbar = ({
  leftSection,
  rightSection,
  dataFacade,
  breakpoint = 'lg',
}: CustomProps) => {
  const { t } = useTranslation()
  const ProcessedLeftSection = () => {
    if (typeof leftSection === 'string')
      return (
        <Group fz="110%" fw="bolder" c="primary" justify="flex-start">
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {leftSection}
          </span>
        </Group>
      )
    return leftSection
  }

  const ProcessedRightSection = () => {
    return (
      <Group fz="110%" fw="bolder" c="primary">
        {dataFacade && (
          <TextInput
            autoFocus
            rightSection={<AppIcon icon="search" />}
            placeholder={
              (dataFacade?.searchOptions?.placeholder &&
                t(dataFacade?.searchOptions?.placeholder)) ||
              t('search')
            }
            // icon={<AppIcon icon="search" />}
            value={dataFacade?.searchOptions?.filter}
            onChange={dataFacade?.searchOptions?.updateFilter}
            {...dataFacade?.searchOptions} // Spread the searchOptions props here
          />
        )}
        {rightSection}
      </Group>
    )
  }

  if (leftSection && !rightSection)
    return (
      <Group w="100%" mih={50} h={50} justify="flex-start" wrap="nowrap">
        <ProcessedLeftSection />
      </Group>
    )

  if (!leftSection && rightSection)
    return (
      <Group w="100%" mih={50} h={50} justify="flex-end" wrap="nowrap">
        <ProcessedRightSection />
      </Group>
    )

  return (
    <>
      <Group
        w="100%"
        mih={50}
        h={50}
        justify="space-between"
        wrap="nowrap"
        visibleFrom={breakpoint}
      >
        <Group bg={themeCfg?.debug ? 'red' : undefined} justify="flex-start">
          <ProcessedLeftSection />
        </Group>
        <Group bg={themeCfg?.debug ? 'blue' : undefined} justify="flex-end">
          <ProcessedRightSection />
        </Group>
      </Group>
      <Stack
        align="flex-start"
        w="100%"
        justify="space-between"
        hiddenFrom={breakpoint}
      >
        <Group
          bg={themeCfg?.debug ? 'red' : undefined}
          w="100%"
          justify="flex-end"
        >
          <ProcessedLeftSection />
        </Group>
        <Group
          bg={themeCfg?.debug ? 'blue' : undefined}
          w="100%"
          justify="flex-end"
        >
          <ProcessedRightSection />
        </Group>
      </Stack>
    </>
  )
}

export default AppToolbar
